import axios from 'axios';

const actions = {
    getDashboard: (context, payload) => {
        return axios.get(`/api/dash-participant?term=${payload}`).then(response => {
            return response.data;
        }).catch(error => {
            return error.response.data;
        });
    },
    getVouchers: (context, payload) => {
        return axios.get('/api/list-vouchers', payload).then(response => {
            return response.data;
        }).catch(error => {
            return error.response.data;
        });
    },
}
export default {
    actions
};